import { render } from "./order_form.vue?vue&type=template&id=196aea62"
import script from "./order_form.vue?vue&type=script&lang=js"
export * from "./order_form.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\software.icarusbd.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__